var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-bordered vessel-list-wrapper"},_vm._l((_vm.multiVesselOffers),function(item,index){return _c('div',{key:("row-mvo-" + index),staticClass:"vessel-panel mult-vessel-offer-wrapper"},[_c('div',{domProps:{"innerHTML":_vm._s(
        ((item.vessels
          .map(function(x) {
            if (_vm.activeBid && x.offerId == _vm.activeBid.offerId) {
              return ("<span class='vessel-name' style='font-weight:bold'>" + (x.vesselName) + "</span> at <span class='rate'>" + (_vm.addCommas(x.rate)) + " " + _vm.currency + "</span>");
            } else {
              return ("<span class='vessel-name'>" + (x.vesselName) + "</span> at <span class='rate'>" + (_vm.addCommas(x.rate)) + " " + _vm.currency + "</span>");
            }
          })
          .join('<br/>')) + " <br/><span style='font-weight:bold;font-size: " + (_vm.isSmallScreen ? '12px' : '16px') + "'>Total for " + (item.vessels.length) + " vessels: <span class='rate'>" + (_vm.addCommas(
          item.vessels
            .map(function(x) {
              return x.rate;
            })
            .reduce(function(a, b) {
              return a + b;
            }, 0)
        )) + " " + _vm.currency + "</span></span>")
      )}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }